<template>
  <nav>
    <ul>
      <!-- Previous Button -->
      <li @click="setPage(currentPage - 1)" :class="{ disable: currentPage === 1 }">
        <a class="pointer">
          <i class="fas fa-angle-double-left"></i>
        </a>
      </li>

      <!-- Page Numbers -->
      <li
        v-for="n in displayedPages"
        :key="n"
        @click="setPage(n)"
      >
        <a :class="['pointer', { active: currentPage === n }]">
          {{ n }}
        </a>
      </li>

      <!-- Next Button -->
      <li @click="setPage(currentPage + 1)" :class="{ disable: currentPage === totalPages }">
        <a class="pointer">
          <i class="fas fa-angle-double-right"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Pagination",
  props: {
    data: {
      type: Array,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
  },
  emits: ["handlePaginate"],
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return this.startIndex + this.itemsPerPage;
    },
    // Logic to determine displayed pages
    displayedPages() {
      const pages = [];
      const start = Math.max(1, this.currentPage - 1); // Start at currentPage - 1
      const end = Math.min(this.totalPages, start + 2); // Show 3 pages maximum

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    setPage(idx) {
      if (idx <= 0 || idx > this.totalPages) return;
      window.scrollTo(0, 0);
      this.currentPage = idx;
      this.$emit("handlePaginate", this.data, this.startIndex, this.endIndex);
    },
  },
  mounted() {
    this.$emit("handlePaginate", this.data, this.startIndex, this.endIndex);
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.disable {
  pointer-events: none;
  opacity: 0.6;
}
.active {
  font-weight: bold;
  text-decoration: underline;
}
</style>
